import { getById } from "@insite/client-framework/Store/Data/DataState";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";

export function getCreateUserAccountStateById(state: ApplicationStateTKCCP, CustomerNumber: string | undefined) {
    return getById(state.createUserAccount, CustomerNumber);
}
